// src/components/dashboard/dashboardStyles.js
import { Card } from "@mui/material";
import { styled } from "@mui/material/styles";

export const KpiCard = styled(Card)(() => ({
  borderRadius: 16,
  boxShadow: "0 4px 10px rgba(0,0,0,0.15)",
}));

export const SoftCard = styled(Card)(() => ({
  borderRadius: 16,
  boxShadow: "0 4px 10px rgba(0,0,0,0.12)",
}));

// ---------------------------------------------------------------------------
// Linguagem visual "premium" do redesign do dashboard: branco, bordas
// discretas, quase nenhuma sombra — reaproveitada por todos os componentes
// novos (DashboardKpiCard, DashboardSection, PortfolioHealth, etc).
// ---------------------------------------------------------------------------

export const PremiumCard = styled(Card)(() => ({
  borderRadius: 12,
  boxShadow: "none",
  border: "1px solid rgba(30, 30, 30, 0.08)",
  backgroundColor: "#ffffff",
}));

export const dashboardTokens = {
  border: "rgba(30, 30, 30, 0.08)",
  textSecondary: "#6b6b64",
  surfaceMuted: "#f7f7f5",
  radius: 12,
};
